<ng-container [ngSwitch]="remoteServiceStore.remoteServiceDiagnosisLoadingStatus$ | async">
  <ng-container *ngrxLet="isE3HeatpumpDevice$ as isE3HeatpumpDevice">
    <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.DataLoading">
      <vi-loader
        body
        [isLoading]="true"
        message="{{ '+REMOTE_SERVICE.LOADING_DATA' | translate }}"
      ></vi-loader>
    </ng-container>

    <ng-container
      *ngIf="
        (installationDetailsStore.isPlusOrProPackage$ | async) || (isRsa$ | async);
        else showLimitedAnomalies
      "
    >
      <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.DataPresent">
        <ng-container *ngTemplateOutlet="isNotLegacyOrHasBoilerSerialDevice"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.EmptySuccessData">
        <ng-container *ngTemplateOutlet="isNotLegacyOrHasBoilerSerialDevice"> </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.ServiceNotAvailable">
        <ng-container
          *ngIf="
            !(deviceStore.isLegacyDeviceWithoutBoilerSerial$ | async);
            else legacyOrNoBoilerSerial
          "
        >
          <app-banner type="info">
            {{
              diagnosisCalculationDataStatus ===
              RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet
                ? ('+REMOTE_SERVICE.DIAGNOSIS_NO_ENOUGH_DATA' | translate)
                : ('+REMOTE_SERVICE.DIAGNOSIS_NO_DATA' | translate)
            }}
          </app-banner>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- No Pro package -->
    <ng-template #showLimitedAnomalies>
      <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.DataPresent">
        <ng-container *ngTemplateOutlet="isNotLegacyOrHasBoilerSerialDevice"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.EmptySuccessData">
        <app-banner type="info">
          {{ '+REMOTE_SERVICE.MISSING_PRO_PACKAGE' | translate }}
        </app-banner>
      </ng-container>
      <ng-container *ngSwitchCase="RemoteServiceDiagnosisLoadingStatus.ServiceNotAvailable">
        <ng-container
          *ngIf="
            !(deviceStore.isLegacyDeviceWithoutBoilerSerial$ | async);
            else legacyOrNoBoilerSerial
          "
        >
          <app-banner type="info">
            {{
              isE3HeatpumpDevice
                ? ('+REMOTE_SERVICE.DIAGNOSIS_NO_ENOUGH_DATA_BASIC_AND_E3_HEATPUMP' | translate)
                : ('+REMOTE_SERVICE.DIAGNOSIS_NO_ENOUGH_DATA' | translate)
            }}
          </app-banner>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #legacyOrNoBoilerSerial>
      <app-banner type="info">{{
        '+REMOTE_SERVICE.LEGACY_DEVICE_MISSING_SERIAL' | translate
      }}</app-banner>
    </ng-template>

    <ng-template #isNotLegacyOrHasBoilerSerialDevice>
      <ng-container
        *ngIf="diagnosisList.length === 0; then noAnomalies; else anomalies"
      ></ng-container>

      <ng-template #anomalies>
        <div class="wrapper-box">
          <div class="diagnosis-wrapper" *ngIf="diagnosisList?.length > 0">
            <!-- 1. Diagnosis Tiles -->
            <ng-container *ngFor="let diagnosis of diagnosisList; let i = index">
              <div
                data-at-active-anomaly-tile
                [attr.data-at-active-anomaly-id]="diagnosis.diagnosis_id"
                [attr.data-at-active]="diagnosis.selected"
                gtm="onSelect"
                gtmAction="Select detailed diagnosis"
                gtmCategory="RemoteInspection"
                class="diagnosis-entry"
                [class.diagnosis-entry-selected]="diagnosis.selected"
                (click)="onDiagnosisEntrySelected($event, diagnosis)"
                *ngIf="canDisplayDiagnosisEntry(i)"
              >
                <div class="diagnosis-entry-header">
                  <span
                    [attr.data-at-anomaly-group]="diagnosis.diagnosis_group"
                    class="diagnosis-entry-header-group"
                  >
                    {{
                      remoteServiceService.getRemoteServicePrefix(diagnosis.diagnosis_group)
                        | translate
                    }}
                  </span>
                </div>
                <div
                  [attr.data-at-anomaly-date]="diagnosis.diagnosis_date"
                  class="diagnosis-entry-details-name"
                >
                  {{ diagnosis.diagnosis_date | date: 'shortDate' }} -
                  {{
                    remoteServiceService.getRemoteServicePrefix(diagnosis.diagnosis_name)
                      | translate
                  }}
                </div>
                <span class="pill-wrapper">
                  <app-pill
                    [attr.data-at-anomaly-priority]="diagnosis.diagnosis_priority"
                    [type]="remoteServiceService.getDiagnosisStatusPillType(diagnosis)"
                  >
                    {{ remoteServiceService.getDescriptionKeyByRiskValue(diagnosis) | translate }}
                  </app-pill>

                  <app-pill
                    *ngIf="diagnosis.diagnosis_id_display"
                    [type]="remoteServiceService.getDiagnosisStatusPillType(diagnosis)"
                  >
                    {{ diagnosis.diagnosis_id_display }}
                  </app-pill>

                  <app-pill *ngFor="let tag of diagnosis?.tags" [attr.data-at-anomaly-tag]="tag">
                    {{ customTranslationsService.REMOTE_SERVICE_DIAGNOSIS_TAGS[tag] | translate }}
                  </app-pill>
                </span>
              </div>

              <div
                class="line-break"
                *ngIf="
                  type === 'anomaly' && canAddLineBreak(diagnosis) && i !== diagnosisList.length - 1
                "
              ></div>
            </ng-container>
          </div>

          <div class="show-more-btn-wrapper" *ngIf="isMoreButtonVisible()">
            <ng-container
              *ngIf="canDisplayAllEntries; then showLessButton; else showMoreButton"
            ></ng-container>
          </div>

          <ng-template #showMoreButton>
            <button
              gtm="onToggle"
              gtmAction="Expand Remote Inspection Diagnosis"
              gtmCategory="RemoteInspection"
              (click)="showMore()"
              mat-stroked-button
            >
              <span>{{ 'GENERAL.BUTTON.SHOW_MORE' | translate }}</span>
              <mat-icon>expand_more</mat-icon>
            </button>
          </ng-template>

          <ng-template #showLessButton>
            <button
              gtm="onToggle"
              gtmAction="Collapse Remote Inspection Diagnosis"
              gtmCategory="RemoteInspection"
              (click)="showLess()"
              mat-stroked-button
            >
              {{ 'GENERAL.BUTTON.SHOW_LESS' | translate }}
              <mat-icon class="inverted-icon">expand_more</mat-icon>
            </button>
          </ng-template>
        </div>

        <ng-container
          *ngIf="remoteServiceStore.selectedDiagnosisEntry$ | async as selectedDiagnosisEntry"
        >
          <ng-container *ngIf="remoteServiceStore.chartExtremes$ | async as chartExtremes">
            <div class="diagnosis-group-title">
              <h2>
                {{
                  remoteServiceService.getRemoteServicePrefix(selectedDiagnosisEntry.diagnosis_name)
                    | translate
                }}
              </h2>
            </div>
            <div class="grid">
              <!-- 2. Diagnosis Description -->
              <app-feature-list-container>
                <div class="flex justify-between">
                  <h3 class="diagnosis-title">
                    {{ '+REMOTE_SERVICE.DIAGNOSIS_TITLE' | translate }}
                  </h3>
                  <button
                    *ngIf="
                      (remoteServiceStore.isDiagnosisInWhitelist(
                        selectedDiagnosisEntry.diagnosis_name
                      ) | async) && (isRsa$ | async)
                    "
                    mat-stroked-button
                    (click)="openDiagnosisExplanation(selectedDiagnosisEntry)"
                    gtm="onSelect"
                    gtmAction="View Diagnosis Explanation"
                    gtmCategory="RemoteInspection"
                    data-at-diagnosis-explanation-btn
                  >
                    {{ '+REMOTE_SERVICE.DIAGNOSIS_EXPLANATION.BUTTON' | translate }}
                  </button>
                </div>
                <div
                  [attr.data-at-anomaly-description]="selectedDiagnosisEntry.diagnosis_text"
                  class="diagnosis-entry-section"
                >
                  {{
                    remoteServiceService.getRemoteServicePrefix(
                      selectedDiagnosisEntry.diagnosis_text
                    ) | translate
                  }}
                </div>
                <!-- No anomaly additional info -->
                <ng-container *ngIf="selectedDiagnosisEntry.diagnosis_anomaly === '0'">
                  <h3 class="diagnosis-subtitle">
                    {{ '+REMOTE_SERVICE.ANOMALY_DESCRIPTION.HEADER' | translate }}
                  </h3>
                  <div
                    class="diagnosis-entry-section"
                    [innerHTML]="
                      '+REMOTE_SERVICE.ANOMALY_DESCRIPTION.NO_ANOMALY' | translate | viTrustHtml
                    "
                  ></div>
                </ng-container>
                <!-- Info anomaly additional info -->
                <ng-container
                  *ngIf="
                    selectedDiagnosisEntry.diagnosis_anomaly === '1' &&
                    selectedDiagnosisEntry.diagnosis_priority === remoteServicePriority.Information
                  "
                >
                  <h3 class="diagnosis-subtitle">
                    {{ '+REMOTE_SERVICE.ANOMALY_DESCRIPTION.HEADER' | translate }}
                  </h3>
                  <div
                    class="diagnosis-entry-section"
                    [innerHTML]="
                      '+REMOTE_SERVICE.ANOMALY_DESCRIPTION.INFO_ANOMALY' | translate | viTrustHtml
                    "
                    alternateClasstyling
                    [baseClassName]="highlightClassName"
                    [alternateStyle]="infoHighlightStyling"
                  ></div>
                </ng-container>
                <!-- Warning anomaly additional info -->
                <ng-container
                  *ngIf="
                    selectedDiagnosisEntry.diagnosis_anomaly === '1' &&
                    (selectedDiagnosisEntry.diagnosis_priority === remoteServicePriority.Warning ||
                      selectedDiagnosisEntry.diagnosis_priority === remoteServicePriority.Critical)
                  "
                >
                  <h3 class="diagnosis-subtitle">
                    {{ '+REMOTE_SERVICE.ANOMALY_DESCRIPTION.HEADER' | translate }}
                  </h3>
                  <div
                    class="diagnosis-entry-section"
                    [innerHTML]="
                      '+REMOTE_SERVICE.ANOMALY_DESCRIPTION.WARNING_ANOMALY'
                        | translate
                        | viTrustHtml
                    "
                    alternateClasstyling
                    [baseClassName]="highlightClassName"
                    [alternateStyle]="warningHighlightStyling"
                  ></div>
                </ng-container>
                <h3 class="diagnosis-subtitle">
                  {{ '+REMOTE_SERVICE.NAME_DESCRIPTION_TITLE' | translate }}
                </h3>
                <div
                  [attr.data-at-anomaly-description]="selectedDiagnosisEntry.diagnosis_text"
                  class="diagnosis-entry-section"
                  [innerHTML]="
                    remoteServiceService.getRemoteServicePrefix(
                      selectedDiagnosisEntry.diagnosis_name
                    ) + '_DESC'
                      | translate
                      | systemTransformedUnits
                      | viTrustHtml
                  "
                ></div>
                <div
                  *ngIf="
                    (installationDetailsStore.isMaintainerWithFreeOrBasicOrPlusPackage$ | async) &&
                    isE3HeatpumpDevice
                  "
                  class="diagnosis-guidance"
                >
                  <mat-icon class="mr-[4px]">info</mat-icon>
                  <div class="flex flex-col">
                    <span class="font-semibold"
                      >{{ '+REMOTE_SERVICE.GUIDANCE.NOTE' | translate }}
                    </span>
                    <p>
                      <ng-container *ngFor="let text of textContent">
                        <ng-container *ngIf="text.type === 'normal'; else linkText">
                          <span>{{ text.content }}</span>
                        </ng-container>
                        <ng-template #linkText>
                          <span
                            class="underline font-semibold cursor-pointer"
                            (click)="scrollToThresholdSettings()"
                            gtm="onSelect"
                            gtmAction="Scroll to threshold settings"
                            gtmCategory="RemoteInspection"
                          >
                            {{ text.content }}</span
                          >
                        </ng-template>
                      </ng-container>
                    </p>
                  </div>
                </div>
              </app-feature-list-container>
              <!-- 3. Recommended Actions -->
              <ng-container *ngIf="selectedDiagnosisEntry.actions.length">
                <app-feature-list-container>
                  <h3 class="diagnosis-title">
                    {{ '+REMOTE_SERVICE.RECOMMENDED_ACTIONS' | translate }}
                  </h3>
                  <app-order-container
                    [order]="i + 1"
                    *ngFor="let action of selectedDiagnosisEntry.actions; let i = index"
                  >
                    <span
                      [attr.data-at-anomaly-recommendation]="action"
                      class="diagnosis-recommendation-entry"
                      [innerHTML]="
                        remoteServiceService.getRemoteServicePrefix(action)
                          | translate
                          | viTrustHtml
                      "
                    >
                    </span>
                  </app-order-container>
                  <div
                    *ngIf="
                      (installationDetailsStore.isMaintainerWithFreeOrBasicOrPlusPackage$
                        | async) && isE3HeatpumpDevice
                    "
                    class="maketing-teaser"
                  >
                    <div
                      class="flex flex-row flex-wrap gap-[12px] justify-start items-center mb-[16px]"
                    >
                      <span class="font-semibold">
                        {{ '+BOOKING.PLAN.FEATURE.MAKETING.TITLE' | translate }}
                      </span>
                      <div class="installation-package">
                        <span>{{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}</span>
                      </div>
                    </div>
                    <h3 class="mb-[16px]">
                      {{ '+BOOKING.PLAN.FEATURE.MAKETING.DESCRIPTION.TITLE' | translate }}
                    </h3>
                    <div class="pro-package-features-list mb-[16px]">
                      <p>
                        {{ '+BOOKING.PLAN.FEATURE.MAKETING.DESCRIPTION.DATA_TRENDING' | translate }}
                      </p>
                      <p>
                        {{
                          '+BOOKING.PLAN.FEATURE.MAKETING.DESCRIPTION.EXTENDED_PARAMETERS'
                            | translate
                        }}
                      </p>
                      <p>
                        {{
                          '+BOOKING.PLAN.FEATURE.MAKETING.DESCRIPTION.PERMANENT_INSPECTION'
                            | translate
                        }}
                      </p>
                    </div>
                    <button
                      class="maketing-teaser__btn w-full"
                      gtm="onGoToPage"
                      gtmAction="Buy pakage"
                      gtmCategory="RemoteInspection"
                      color="primary"
                      [routerLink]="['/booking']"
                      mat-flat-button
                    >
                      {{ '+BOOKING.PLAN.FEATURE.MAKETING.BUTTON' | translate }}
                    </button>
                  </div>
                </app-feature-list-container>
              </ng-container>
              <!-- 4. Features Charts Rangepicker -->
              <ng-container
                *ngIf="
                  remoteServiceStore.getChartFeatures(selectedDiagnosisEntry.relevant_adf) | async
                "
              >
                <ng-container
                  *ngIf="remoteServiceStore.chartTimestamps$ | async as chartTimestamps"
                >
                  <app-feature-list-container class="actions-container">
                    <span class="chart-datepicker">
                      <span class="chart-datepicker-text"
                        >{{ '+REMOTE_SERVICE.DATEPICKER_TOOLTIP' | translate }}:</span
                      >
                      <mat-form-field appearance="fill" (click)="picker.open()">
                        <mat-label>{{ '+GENERAL.DATEPICKER.DAY_PICKER' | translate }}</mat-label>

                        <mat-date-range-input
                          matDateRangePicker
                          [formGroup]="dateRange"
                          [rangePicker]="picker"
                          [min]="minRangepickerDate"
                          [max]="maxRangepickerDate"
                          gtm="onSelect"
                          gtmAction="Remote Inspection Range"
                          gtmCategory="RemoteInspection"
                          data-at-rangepicker
                        >
                          <input
                            readonly
                            matStartDate
                            formControlName="start"
                            placeholder="{{ '+GENERAL.RANGEPICKER_START_DATE' | translate }}"
                            fieldTextContentTooltip
                          />
                          <input
                            readonly
                            matEndDate
                            formControlName="end"
                            placeholder="{{ '+GENERAL.RANGEPICKER_END_DATE' | translate }}"
                            (dateChange)="setDayRange()"
                            fieldTextContentTooltip
                          />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>

                        <mat-error
                          data-at-rangepicker-error
                          *ngIf="dateRange.controls.start.hasError('matStartDateInvalid')"
                          >{{
                            '+GENERAL.RANGEPICKER.ERROR.INVALID_START_DATE' | translate
                          }}</mat-error
                        >
                        <mat-error
                          data-at-rangepicker-error
                          *ngIf="dateRange.controls.end.hasError('matEndDateInvalid')"
                          >{{
                            '+GENERAL.RANGEPICKER.ERROR.INVALID_END_DATE' | translate
                          }}</mat-error
                        >
                        <button
                          data-at-rangepicker-clear-btn
                          class="rangepicker-clear-btn"
                          *ngIf="customDateRange"
                          mat-icon-button
                          gtm="onClearSearch"
                          gtmAction="Remote Service date"
                          gtmCategory="remoteService"
                          (click)="resetRange($event)"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </mat-form-field>
                    </span>

                    <ng-container
                      [ngSwitch]="
                        remoteServiceStore.remoteServiceDiagnosisChartLoadingStatus$ | async
                      "
                    >
                      <ng-container
                        *ngSwitchCase="RemoteServiceDiagnosisChartLoadingStatus.DataPresent"
                      >
                        <ng-container *ngIf="isEntrySelected">
                          <app-remote-service-chart
                            *ngIf="
                              remoteServiceStore.getChartFeatures(
                                selectedDiagnosisEntry.relevant_adf
                              ) | async as chartFeatures
                            "
                            [chartExtremes]="chartExtremes"
                            [chartTimestamps]="chartTimestamps"
                            [chartFeatures]="chartFeatures"
                            [titleKey]="selectedDiagnosisEntry.diagnosis_name"
                            [chartType]="'line'"
                          ></app-remote-service-chart>
                        </ng-container>

                        <ng-container
                          *ngIf="selectedDiagnosisEntry.diagnosis_configurations?.length"
                        >
                          <span class="separator"></span>
                          <div #thresholdSettings>
                            <app-remote-service-thresholds
                              [thresholds]="selectedDiagnosisEntry.diagnosis_configurations"
                              [diagnosisGroup]="selectedDiagnosisEntry.diagnosis_group"
                              [thresholdsExpanded]="thresholdsExpanded"
                              (thresholdsToggled)="onThresholdsToggle()"
                            ></app-remote-service-thresholds>
                          </div>
                        </ng-container>
                      </ng-container>

                      <ng-container
                        *ngSwitchCase="RemoteServiceDiagnosisChartLoadingStatus.DataLoading"
                      >
                        <vi-loader
                          body
                          [isLoading]="true"
                          message="{{ '+REMOTE_SERVICE.LOADING_DATA' | translate }}"
                        ></vi-loader>
                      </ng-container>

                      <ng-container *ngSwitchCase="RemoteServiceDiagnosisChartLoadingStatus.NoData">
                        <app-banner
                          *ngIf="!(remoteServiceStore.chartDataStatus$ | async).loading"
                          type="info"
                          >{{ '+REMOTE_SERVICE.ERROR_DATA_NOT_FOUND' | translate }}</app-banner
                        >
                      </ng-container>
                    </ng-container>
                  </app-feature-list-container>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-template>
      <ng-template #noAnomalies>
        <ng-container
          *ngIf="
            !(
              (installationDetailsStore.isMaintainerWithFreeOrBasicOrPlusPackage$ | async) &&
              isE3HeatpumpDevice
            )
          "
        >
          <div class="no-anomalies-wrapper">
            <ng-container
              *ngIf="
                diagnosisCalculationDataStatus ===
                  RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet ||
                  !(activeErrorsStore.isDeviceOrLockedSystemError$ | async);
                else arrowMagnifyingGlassImg
              "
            >
              <img class="error-img" src="assets/img/thumbs-up-installer.svg" />
            </ng-container>
            <ng-template #arrowMagnifyingGlassImg>
              <img class="error-img" src="assets/img/arrow-google.png" />
            </ng-template>
            <span
              ><p
                class="no-anomalies-text"
                [innerHTML]="
                  '+REMOTE_SERVICE.NO_ANOMALIES_DETECTED_DESCRIPTION_PAGE' | translate | viTrustHtml
                "
              ></p
            ></span>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            (installationDetailsStore.isMaintainerWithFreeOrBasicOrPlusPackage$ | async) &&
            isE3HeatpumpDevice
          "
        >
          <app-banner type="info">
            {{
              '+REMOTE_SERVICE.DIAGNOSIS_NO_ENOUGH_DATA_BASIC_AND_E3_HEATPUMP' | translate
            }}</app-banner
          >
        </ng-container>
      </ng-template>
    </ng-template>
  </ng-container>
</ng-container>
